import CryptoJS from 'crypto-js';

const fetchAndHashPdf = async (pdfFile: string): Promise<string> => {
  try {
    const response = await fetch(pdfFile);
    const arrayBuffer = await response.arrayBuffer();
    const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer);
    return CryptoJS.SHA256(wordArray).toString(CryptoJS.enc.Hex);
  } catch (error) {
    console.error('Error fetching or hashing PDF:', error);
    throw error;
  }
};

export default fetchAndHashPdf;
